import React from "react";
import RootLayout from "./RootLayout";
import whiteLogo from "../assets/images/logo-new.png";
import { Layout, Menu, Icon, Badge } from "antd";
import { TTranslate } from "../../service/locale/TranslationService";
import { TPresentable } from "../../presenter/withStore";
import { IUser } from "../../model/user/User";
import { IRequest } from "../../model/request/Request";

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

export interface Props {
  router: any;
  children?: any;
  translate: TTranslate;
}
export interface State extends TPresentable {}

export default class AppLayout extends React.Component<Props, State> {
  private subscriptionId: number = 0;
  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { children, translate, router } = this.props;

    const { user }: { user: IUser } = this.state as any;
    const { requests }: { requests: IRequest[] } = this.state as any;
    const logoOnClickLink = "https://www.pravosudje.ba/";
    const redirect = path => {
      router.push({
        pathname: path
      });
    };

    const unreadRequests = (requests: IRequest[]) => {
      return requests.filter(request => request.read === false).length;
    };

    const getCurrentLocation = () => {
      if (router.location.path === "/home") {
        router.location.path = "/forms";
      }
      if (router.location.path === "/") {
        router.location.path = "/forms";
      }
      return [router.location.path];
    };

    return (
      <RootLayout {...this.props}>
        <div className="base_layout">
          <Layout style={{ minHeight: "100vh" }}>
            <Header
              className="header"
              style={{ position: "fixed", zIndex: 2, width: "100%" }}
            >
              <div className="logo">
                <a href={logoOnClickLink} target={"_blank"}>
                  <img src={whiteLogo} alt="Logo" />
                </a>
              </div>
              <Menu
                theme="dark"
                mode="horizontal"
                style={{ lineHeight: "64px" }}
                defaultSelectedKeys={getCurrentLocation()}
              >
                <Menu.Item
                  key="/forms"
                  style={{ float: "left" }}
                  onClick={() => redirect("/forms")}
                >
                  {translate("front_office_layout.current_reports")}
                </Menu.Item>
                <Menu.Item
                  key="/previous-forms"
                  style={{ float: "left" }}
                  onClick={() => redirect("/previous-forms")}
                >
                  {translate("front_office_layout.past_reports")}
                </Menu.Item>

                <SubMenu
                  style={{ float: "right" }}
                  title={
                    <span>
                      {translate("app_layout.signed_as")}
                      <strong> {user && user.username}</strong>
                    </span>
                  }
                >
                  <Menu.Item
                    key="setting:1"
                    onClick={() => redirect("/settings")}
                  >
                    <span>
                      <Icon type="setting" />
                      {translate("app_layout.settings")}
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="setting:2"
                    onClick={() => redirect("/dologout")}
                  >
                    <span>
                      <Icon type="logout" />
                      {translate("app_layout.logout")}
                    </span>
                  </Menu.Item>
                </SubMenu>

                <span style={{ float: "right" }}>
                  <Badge dot={requests ? unreadRequests(requests) > 0 : false}>
                    <Icon
                      key="zahtjevi"
                      type="mail"
                      onClick={() => redirect("/requests")}
                    />
                  </Badge>
                </span>
              </Menu>
            </Header>
            <Layout style={{ marginTop: 64 }}>
              <Layout style={{ padding: "24px 24px 24px" }}>
                <Content
                  style={{
                    background: "#fff",
                    padding: 24,
                    margin: 0,
                    minHeight: 280
                  }}
                >
                  {children}
                </Content>
                <Footer style={{ textAlign: "center" }}>
                  {`© ${new Date().getFullYear()} Visoko sudsko i tužilačko vijeće`}
                </Footer>
              </Layout>
            </Layout>
          </Layout>
        </div>
      </RootLayout>
    );
  }
}
